
import uiRouter from 'angular-ui-router';
import ngAnimate from 'angular-animate';
import {appContainerDirective} from './appContainer.directive';
import {models} from '../../models/models';

export const appContainer = angular.module('appContainer', [
  uiRouter,
  models.name,
  ngAnimate
]).config(($locationProvider, $stateProvider, $urlRouterProvider, $animateProvider) => {
  $locationProvider.html5Mode(true);
  // Default landing page, set to home
  $urlRouterProvider.otherwise('/');
  // Parent state for all other top level menu components -
  $stateProvider.state('app', {
    abstract: true,
    // url: '/app',
    template: '<appContainer></appContainer>'
  });

  $animateProvider.classNameFilter(/^((?!(fa-spinner)).)*$/);

}).run(['$rootScope', '$state', '$stateParams', '$window', '$location', 'uiService', ($rootScope, $state, $stateParams, $window, $location, uiService) => {

    $window.ga('create', 'UA-455023-3', 'auto');

    $rootScope.$on('$stateChangeStart', (event, toState, toStateParams) => {
    // log where you are transitioning to
    $rootScope.toState = toState;
    $rootScope.toStateParams = toStateParams;
  });

  $rootScope.$on('$stateChangeSuccess', function() {
    $window.ga('send', 'pageview', $location.path());

    $window.scrollTo(0, 0);

    uiService.showMenu(true);

    //console.log($state.current);
    //console.log($state.current.data);
    if ($state.current.data){
        $rootScope.metaTitle = $state.current.data.metaTitle;
        $rootScope.metaDescription = $state.current.data.metaDescription;
        $rootScope.metaKeywords = $state.current.data.metaKeywords;
    } else {
        $rootScope.metaTitle = 'Skip hire. Skip Bins and bin hire - Online skip bin hire | Rentaskip Australia';
        $rootScope.metaDescription = 'Skip bins and skip hire Australia wide. Reliable service for residential, trade and business customers. Book online.';
        $rootScope.metaKeywords = 'Skip Bins,Skip hire, Skip Bin, bin hire, Skips, Australia Skip Hire';
    }

  });

}])
.directive('appcontainer', appContainerDirective);



/** WEBPACK FOOTER **
 ** ./src/app/components/appContainer/appContainer.js
 **/